import * as React from "react";
import HeaderNavMenu from "./HeaderNavMenu";
import { Link } from '@tanstack/react-router';
import BasketButton from "../atoms/BasketButton";
import MenuButton from "../atoms/MenuButton";
import AccountButton from "@/components/atoms/AccountButton.tsx";
import { useRouterState } from "@tanstack/react-router";
import { SidebarMenu } from "./SidebarMenu";
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getSystemGroups } from '@/services';
import { MENU_SYSTEMS_STALE_TIME_5_MINS } from '@/config';
import AccountIconButton from '@/components/atoms/AccountIconButton';

const systemsQueryOptions = queryOptions({
  queryKey: ['systems'],
  queryFn: getSystemGroups,
  staleTime: MENU_SYSTEMS_STALE_TIME_5_MINS,
});
export default function Header() {
  /* Getting the router context, using a match: https://tanstack.com/router/latest/docs/framework/react/guide/router-context#processing-accumulated-route-context */
  const matches = useRouterState({ select: (s) => s.matches });
  const root = matches.find((match) => match.id === "__root__");
  const [userIsLoggedIn, setUserIsLoggedIn] = React.useState(
    root?.context.isLoggedIn || false,
  );
  const [sidebarMenuIsOpen, setSidebarMenuIsOpen] = React.useState(false);
  const { data } = useQuery(systemsQueryOptions);

  React.useEffect(() => {
    // Add the event listener under a useEffect so it doesn't get executed on the server.
    const root = document.getElementById("root");
    if (root) {
      root?.addEventListener("userStatus", (event: Event) => {
        const user = window.__user__;
        // @ts-expect-error - event.detail is not typed
        const isLoggedIn = event.detail.isLoggedIn;
        if (user) {
          user.isLoggedIn = isLoggedIn;
          setUserIsLoggedIn(isLoggedIn);
        }
      });
    }
    return function removeListener() {
      root?.removeEventListener("userStatus", () => {
        console.log("Removing event listener");
      });
    };
  });

  const toggleSidebarMenu = () => {
    setSidebarMenuIsOpen(!sidebarMenuIsOpen);
  };

  return (
    <div className="fixed w-full top-0 left-0 flex flex-row header items-center px-5 py-2 md:p-8">
      <div className="basis-1/3 md:hidden">
          <SidebarMenu
            isOpen={sidebarMenuIsOpen}
            toggleOpen={toggleSidebarMenu}
            systems={data}
            userIsLoggedIn={userIsLoggedIn}
          />
          <MenuButton onClick={toggleSidebarMenu} />
      </div>
      <div className="basis-1/3 shrink-0 md:basis-2/8 lg:basis-1/8">
        <Link to="/">
          <img
            src="/public/omeo_logo_v4.svg"
            alt="OMEO Cycles Logo"
          />
        </Link>
      </div>
      <div className="hidden md:flex md:basis-4/8 lg:basis-5/8 md:shrink-0 justify-center items-center">
        <HeaderNavMenu />
      </div>
      <div className="hidden md:flex md:basis-2/8 lg:basis-1/8 gap-x-4 items-center justify-end md:shrink-0">
          <BasketButton />
          <AccountButton isLoggedIn={userIsLoggedIn} />
      </div>
      <div className="basis-1/3">
        <div className="md:hidden flex flex-row gap-x-3 items-center justify-end">
          <BasketButton />
          <AccountIconButton isLoggedIn={userIsLoggedIn} />
        </div>
      </div>
    </div>
  );
}
